// extracted by mini-css-extract-plugin
export var container = "Timeline-module--container--3b74b";
export var event = "Timeline-module--event--2e9fe";
export var eventDate = "Timeline-module--event-date--58f89";
export var eventDescription = "Timeline-module--event-description--2999a";
export var eventHeader = "Timeline-module--event-header--619b5";
export var eventTitle = "Timeline-module--event-title--4878a";
export var eventToggle = "Timeline-module--event-toggle--70c82";
export var line = "Timeline-module--line--620aa";